// Comfortable wraps long labels, for writing a quote; compact keeps every line
// on one line, for reading back a long quote. The choice follows the user from
// one session to the next.
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import IconButton from "@react/shared/ui/IconButton"

const DensityToggle = ({ compact, onToggle }) => (
  <IconButton
    size       = "sm"
    onClick    = {onToggle}
    title      = {I18n.t(compact ? "quotes.builder.density.to_comfortable" : "quotes.builder.density.to_compact")}
    aria-label = {I18n.t(compact ? "quotes.builder.density.to_comfortable" : "quotes.builder.density.to_compact")}
    aria-pressed = {compact}
  >
    <FontAwesomeIcon icon={compact ? "up-right-and-down-left-from-center" : "down-left-and-up-right-to-center"} />
  </IconButton>
)

export default DensityToggle
